import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { COLORS } from 'app/constants/STYLES'

import {
	SectionContainer,
	SectionWrap,
	LoginWrapper,
	LoginSubContainer,
} from './styles'
import { LoginHeader } from './AuthContainers'
import LoginForm from './Forms/LoginForm'
import VerifySection from './VerifySection'
import { ThemeContext } from 'theme/ThemeProvider'

const LoginSection = () => {
	const { isDarkMode } = React.useContext(ThemeContext)
	const [loginSuccess, setLoginSuccess] = useState('')
	const { t } = useTranslation()
	return (
		<SectionContainer>
			{loginSuccess?.length > 5 ? (
				<VerifySection
					authSuccess={loginSuccess}
					setAuthSuccess={setLoginSuccess}
				/>
			) : (
				<SectionWrap>
					<LoginWrapper>
						<LoginHeader label={t('login')} />
						<LoginSubContainer>
							<LoginForm setLoginSuccess={setLoginSuccess} />
						</LoginSubContainer>
					</LoginWrapper>
				</SectionWrap>
			)}
		</SectionContainer>
	)
}

export default React.memo(LoginSection)
